import { Reveal, MaskLines } from "./motion";

export const SectionHead = ({ index, eyebrow, lines, text, dark = false, aside }) => (
  <div className="grid gap-8 md:grid-cols-12 md:items-end">
    <div className="md:col-span-8">
      <Reveal>
        <p className={`eyebrow mb-5 flex items-center gap-3 ${dark ? "text-[color:var(--ngp-teal)]" : "text-[color:var(--ngp-teal-ink)]"}`}>
          {index && <span className={dark ? "text-white/60" : "text-[color:var(--ngp-muted)]"}>{index}</span>}
          <span className="h-px w-8 bg-current" />{eyebrow}
        </p>
      </Reveal>
      <h2 className="font-display text-4xl font-semibold leading-[0.98] sm:text-5xl lg:text-6xl">
        <MaskLines lines={lines} onLoad={false} delay={0} />
      </h2>
    </div>
    {(text || aside) && (
      <Reveal delay={0.15} className="md:col-span-4">
        {text && <p className={`text-base leading-relaxed md:text-lg ${dark ? "text-white/75" : "text-[color:var(--ngp-muted)]"}`}>{text}</p>}
        {aside}
      </Reveal>
    )}
  </div>
);
